import React, {useMemo} from "react";
import NumberFormat from "react-number-format";
import Select from "react-select";

export const NumberFormatField = function (props) {
    let {formik, name, className} = props;
    let meta = formik.getFieldMeta(name);
    let handleChange = data => {
        const changeEvent = {
            target: {
                name: name,
                value: data.floatValue
            }
        };
        formik.handleChange(changeEvent);
    }
    return (
        <>
            <NumberFormat thousandSeparator={','} decimalSeparator={'.'} className={className}
                          autoComplete="off" {...props}
                          value={!Number.isNaN(Number.parseFloat(meta.value)) ? Number.parseFloat(meta.value).toLocaleString("en-US", {maximumFractionDigits: 10}) : 0}
                          onValueChange={handleChange}/>
            {meta.touched && meta.error ? (<span className="text-danger  d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}

export const InputField = function (props) {
    let {formik, name, type, className, placeholder} = props;
    let meta = formik.getFieldMeta(name);
    let prop = formik.getFieldProps(name);
    return (
        <>
            <input type={type || 'text'} {...prop} placeholder={placeholder}
                   className={"form-control " + (className || '')}/>
            {meta.touched && meta.error ? (<span className="text-danger d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}

export const InputFileField = function (props) {
    let {formik, name, placeholder, accept} = props;
    let meta = formik.getFieldMeta(name);
    const onChange = (event) => {
        let file = event.target.files[0];
        let acceptList = accept.split(",").filter(Boolean)

        if (file && acceptList.some(accept => accept.trim() === file.type)) {
            formik.setFieldValue(name, file)
        }
    }
    let titleFile = useMemo(function () {
        if (meta.value) {
            return meta.value.name
        } else {
            return placeholder
        }
    }, [placeholder, meta.value])
    return (
        <>
            <label className="label-input-file" title={titleFile}>
                <input type="file" accept={accept} onChange={onChange}/> {titleFile}
            </label>
            {meta.touched && meta.error ? (<span className="text-danger  d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}

export const SelectField = function (props) {
    let {formik, name, options, placeholder, className} = props;
    let meta = formik.getFieldMeta(name);
    let prop = formik.getFieldProps(name);
    return (
        <>
            <select {...prop} value={prop.value || ''} className={className}>
                {placeholder && <option value="">{placeholder}</option>}
                {options?.map(option => <option key={option.key} value={option.key}>{option.value}</option>)}
            </select>
            {meta.touched && meta.error ? (<span className="text-danger  d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}
export const ReactSelectField = function (props) {
    let {formik, name, options, placeholder, className} = props;
    let meta = formik.getFieldMeta(name);
    const handleChange = (event) => {
        formik.setFieldValue(name, event.value)
    }
    const colourStyles = {
        control: (styles, {isFocused}) => {
            styles.borderColor = isFocused ? "#f6919a" : "#ced4da"
            styles.boxShadow = isFocused ? "#f6919a" : "#ced4da"
            styles[':hover'] = {
                borderColor: "#f6919a",
                boxShadow: "#f6919a",
            }
            return styles
        },
        input: (styles, {isFocused}) => {
            styles.boxShadow = isFocused ? "#f6919a" : "#ced4da"
            styles.borderColor = isFocused ? "#f6919a" : "#ced4da"
            return styles
        },
        option: (styles, {isFocused}) => {
            return {
                ...styles,
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
                color: isFocused ? "#ed1b2e" : "#1b365d",
                ':active': {
                    ...styles[':active'],
                    color: "#ed1b2e",
                    backgroundColor: "#FFFFFF",
                },
            };
        }
    };
    return (
        <>
            <Select
                styles={colourStyles}
                className={className}
                placeholder={placeholder}
                value={options.find(option => option.value === meta.value)}
                options={options}
                name={name}
                onChange={handleChange}
            />
            {meta.touched && meta.error ? (<span className="text-danger  d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}
export const RadioField = function (props) {
    let {formik, name, options} = props;
    let meta = formik.getFieldMeta(name);
    let prop = formik.getFieldProps(name);
    return (
        <>
            {options?.map(opt => {
                let value = opt.key;
                return (
                    <label className="radio-inline" title="" key={opt.key}>
                        <input {...prop} type="radio" value={opt.key} checked={meta.value == value}/>{opt.text}
                    </label>
                );
            })}
            {meta.touched && meta.error ? (<span className="text-danger  d-inline-block mt-2">{meta.error}</span>) : null}
        </>
    );
}
export const TextareaField = function (props) {
    let {formik, name, className, id, placeholder,rows} = props;
    let meta = formik.getFieldMeta(name);
    let prop = formik.getFieldProps(name);
    return (
        <>
            <textarea id={id}
                      rows={rows}
                      {...prop}
                      className={"form-control " + (className || '')}
                      placeholder={placeholder}/>
            {meta.touched && meta.error ? (<p className="text-danger pt-3">{meta.error}</p>) : null}
        </>
    )
}